export default __webpack_public_path__ + "static/cruiselines-carnival-kids-2-73f4eced23343f7ef7b4dc35c2250c77.jpg";